import React, { Component } from "react";
import "../asserts/css/login.css";
import title from "../asserts/images/LYCmark.png";
import $ from "jquery";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import ErrorsMessageToast from "./errorsMessageToast";
import { message } from "antd";
import store from "./redux/store";

/**
 * dropDown 最后一项为后端基地址；无则用 /api-backend/ 走 dev 代理。
 * 注意：若为 http://localhost:8080（无尾斜杠），直接 + "login/login" 会得到
 * http://localhost:8080login/login → 后端 404；Postman 手写 URL 带斜杠则正常。
 */
const getServerIPFromStore = () => {
  const dropDown = store.getState().dropDown;
  let base =
    dropDown && dropDown.length > 0 ? dropDown[dropDown.length - 1] : null;
  if (base == null || base === "") {
    base = "/api-backend";
  }
  if (typeof base !== "string") {
    base = "/api-backend";
  }
  if (/^https?:\/\//i.test(base)) {
    return base.endsWith("/") ? base : base + "/";
  }
  return base.endsWith("/") ? base : base + "/";
};

axios.defaults.withCredentials = true;
/**
 * 管理者ログイン画面
 * 20201019 劉林涛
 */
class Login extends Component {
  constructor(props) {
    super(props);
    
    console.log("Redux dropDown:", store.getState().dropDown);
    console.log("Resolved serverIP:", getServerIPFromStore());

  
    this.state = {
      serverIP: getServerIPFromStore(),
      errorsMessageShow: false,
      errorsMessageValue: "",
      pic: "",
      remberPassWord: false,
    };
  }

  componentWillMount() {
    $("#login").attr("disabled", true);
    axios
      .post(this.state.serverIP + "subMenu/getCompanyDate")
      .then((response) => {
        this.setState({
          companyName: response.data.companyName,
          pic: response.data.companyLogo,
        });
      })
      .catch((error) => {
        console.error("Error - " + error);
      });
    axios
      .post(this.state.serverIP + "login/init")
      .then((resultMap) => {
        // 仅在后端明确返回布尔 true 时跳转；任意 truthy（如 HTML 字符串、{}）会误入主菜单并导致下拉未初始化崩溃
        if (resultMap && resultMap.data === true) {
          this.props.history.push("/subMenuManager");
        }
      })
      .catch(() => {});
  }

  componentDidMount() {
    this.loadAccountInfo();
  }

  loadAccountInfo = () => {
    //读取Cookie
    let arr,
      reg = new RegExp("(^| )" + "accoutInfo" + "=([^;]*)(;|$)");
    let accoutInfo = "";
    if ((arr = document.cookie.match(reg))) {
      accoutInfo = unescape(arr[2]);
    } else {
      accoutInfo = null;
    }

    if (!Boolean(accoutInfo)) {
      return false;
    } else {
      let userName = "";
      let passWord = "";

      let i = new Array();
      i = accoutInfo.split("&");
      userName = i[0];
      passWord = i[1];

      $("#employeeNo").val(userName);
      $("#password").val(passWord);
      this.setState({ remberPassWord: true });
    }
  };

  /**
   * ログインボタン
   */
  login = () => {
    var loginModel = {};
    loginModel["employeeNo"] = $("#employeeNo").val();
    loginModel["password"] = $("#password").val();
    axios
      .post(this.state.serverIP + "login/login", loginModel)
      .then((result) => {
        if (
          result.data.errorsMessage === null ||
          result.data.errorsMessage === undefined
        ) {
          message.success("ログイン成功");
          if (this.state.remberPassWord) {
            let accoutInfo =
              $("#employeeNo").val() + "&" + $("#password").val();
            let Days = 7; //Cookie保存時間
            let exp = new Date();
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
            document.cookie =
              "accoutInfo" +
              "=" +
              escape(accoutInfo) +
              ";expires=" +
              exp.toGMTString();
          } else {
            let exp = new Date();
            exp.setTime(exp.getTime() - 1);
            let accoutInfo = document.cookie;
            var cookie_pos = accoutInfo.indexOf("accoutInfo");

            if (cookie_pos != -1) {
              document.cookie =
                "accoutInfo" + "=" + " " + ";expires=" + exp.toGMTString();
            }
            $("#employeeNo").val(" ");
            $("#password").val(" ");
          }
          this.props.history.push("/subMenuManager");
        } else {
          this.setState({
            errorsMessageShow: true,
            errorsMessageValue: result.data.errorsMessage,
          });
        }
      })
      .catch((error) => {
        this.setState({
          errorsMessageShow: true,
          errorsMessageValue:
            "エラーが発生してしまいました、画面をリフレッシュしてください",
        });
      });
  };

  handleChecked = () => {
    this.setState({
      remberPassWord: !this.state.remberPassWord,
    });
  };

  render() {
    const { errorsMessageValue } = this.state;
    return (
      <div className="loginBody">
        <div style={{ marginTop: "10%" }}>
          <div
            style={{ display: this.state.errorsMessageShow ? "block" : "none" }}
          >
            <ErrorsMessageToast
              errorsMessageShow={this.state.errorsMessageShow}
              message={errorsMessageValue}
              type={"danger"}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <img
              className="mb-4"
              alt="title"
              src={this.state.pic}
              style={{ width: "65px" }}
            />
            {"   "}
            <a className="loginMark">{this.state.companyName}</a>
          </div>
          <Form className="form-signin" id="loginForm">
            <Form.Group /*controlId="formBasicEmail"*/>
              <Form.Control
                id="employeeNo"
                name="employeeNo"
                maxLength="6"
                type="text"
                placeholder="社员番号"
                onChange={this.setReadOnly}
                required
              />
              <Form.Control
                id="password"
                name="password"
                maxLength="12"
                type="password"
                placeholder="Password"
                onChange={this.setReadOnly}
                required
              />
            </Form.Group>
            <div style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                checked={this.state.remberPassWord}
                onChange={this.handleChecked}
                value={this.state.remberPassWord}
              />
              <span> ログイン情報保存</span>
            </div>
            <Button
              variant="primary"
              id="login"
              onClick={this.login}
              block
              type="button"
            >
              ログイン
            </Button>
          </Form>
        </div>
      </div>
    );
  }
}
export default Login;
